/**
    companyName: '', // 分公司
    siteName: '', // 服务平台
    ledgerName: '', // 会计主体
    businessType: '',// 业务类型
    feeTaskType: '', 任务类型
    amount: '', 含税总金额
    taxAmount: '', 税额
    remark: '', 备注
    noTaxAmount: '', 不含税总金额
    supplierComfirmAmount: '' 确认金额
 *
 */
export default class LoadAndUnloadClass {
    constructor({ companyName, siteName, ledgerName, businessType, feeTaskType, amount, taxAmount, remark, supplierComfirmAmount, noTaxAmount }) {
        this.companyName = companyName || '';
        this.siteName = siteName || '';
        this.ledgerName = ledgerName || '';
        this.businessType = businessType || '';
        this.feeTaskType = feeTaskType || '';
        this.amount = (amount + '') || '';
        this.taxAmount = (taxAmount + '') || '';
        this.remark = remark || '';
        this.noTaxAmount = noTaxAmount || '';
        this.supplierComfirmAmount = supplierComfirmAmount || '';
        if (this.taxAmount === 'undefined') {
            this.taxAmount = '';
        }
    }
}

export function initOrgonaztion(data) {
    return new LoadAndUnloadClass(data);
}